<template>
  <div class="card">
    <h1>{{ __('Logga in') }}</h1>
    <input type="text" v-model="$v.email.$model" :placeholder="__('E-post')" />
    <input
      type="password"
      v-model="$v.password.$model"
      :placeholder="__('Lösenord')"
      v-on:keyup.enter="login"
    />
    <div class="row forced margin-bottom-x2 text-small">
      <label for="remember" class="checkboxes" style="flex: 1"
        ><input type="checkbox" id="remember" v-model="rememberMe" /><span
          class="checkmark"
        ></span>
        {{ __('Kom ihåg mig') }}</label
      >
      <router-link to="/reset-password"
        >{{ __('Glömt lösenord') }}?</router-link
      >
    </div>

    <el-message warning class="margin-bottom-x2" v-if="warningMessage">
      {{ warningMessage }}
    </el-message>
    <el-message warning class="margin-bottom-x2" v-if="errorMessage">
      {{ errorMessage }}
    </el-message>
    <el-message info class="margin-bottom-x2" v-if="infoMessage">
      {{ infoMessage }}
    </el-message>

    <div class="row">
      <button
        class="button margin-bottom-x3"
        @click="login"
        :disabled="$v.$invalid"
      >
        {{ __('Logga in') }}
      </button>
    </div>

    <strong class="margin-bottom-x1"
      >{{ __('Ny på My Equardian?') }}
      <router-link to="/signup">{{ __('Bli medlem') }}</router-link></strong
    >
    <el-loader margin-top v-if="isLoading" />
  </div>
</template>
<script>
import auth from 'services/auth.js'
import { required, email } from 'vuelidate/lib/validators'

import logScope from 'log-scope'
const log = logScope('Login')

export default {
  data () {
    return {
      email: '',
      password: '',
      warningMessage: '',
      infoMessage: '',
      errorMessage: '',
      isLoading: false,
      rememberMe: false,
    }
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
  mounted () {
    if (auth.getUser()) {
      log.debug('Already logged in')
      this.$router.replace('/')
    }
  },
  methods: {
    reset () {
      this.warningMessage = ''
      this.infoMessage = ''
      this.errorMessage = ''
    },
    async login () {
      this.isLoading = true
      this.reset()
      try {
        await auth.loginAsync(this.email, this.password)
        this.$store.commit('setOrderId', null)
        this.$router.push('/')
      } catch (err) {
        this.isLoading = false
        this.errorMessage = this.__(err.message || err)
        log.error('Could not log in', err)
      }

      /*
      this.reset()

      this.isLoading = true

      try {
        await auth.setSessionMode()
        await auth.signInWithEmailAndPassword(
          this.email,
          this.password
        )
        this.$router.replace('/')
      } catch (err) {
        this.errorMessage = this.__(
          'Kunde inte logga in. Angav du rätt e-post och lösenord?'
        )
        log.error('Could not log in', err)
      }

      this.isLoading = false
    */
    },
  },
}
</script>
